import { IApplicationState } from '../../types/redux';
import { selectMortgagePromos } from './selectMortgagePromos';

export const selectHasMortgagePromos = (state: IApplicationState): boolean => {
  const promos = selectMortgagePromos(state);

  return promos.length > 0;
};
